import { type GridColumnVisibilityDefinition } from '../types';

export const isAvailableColumnFactory: (
    columnDefinitions: GridColumnVisibilityDefinition[]
) => (columnId: GridColumnVisibilityDefinition['columnId']) => boolean = (columnDefinitions) => (columnId) => {
    const columnDefinition = columnDefinitions.find((definition) => definition.columnId === columnId);

    return columnDefinition?.isAvailable?.() ?? true;
};
